import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bf4e013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-col-12 q-col-sm-6 q-col-md-3 q-d-block q-d-md-none q-pb-3 q-pb-sm-0 q-p-0 q-p-sm-1" }

import {inject} from "vue";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {SmartSearchTranslationsInterface} from "@/core/types";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFiltersButton',
  setup(__props) {

const filtersStore = useFiltersStore();
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "q-btn q-btn q-btn-danger q-rounded-3 q-shadow-sm",
      id: "showFiltersOnMobile",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).showFiltersOnMobile && _unref(filtersStore).showFiltersOnMobile(...args)))
    }, _toDisplayString(_unref(SmartSearchTranslations).filters.show), 1)
  ]))
}
}

})